<template>
  <div class="sync-modal-root" v-if="visible">
    <div v-if="screen === 'modal'" class="overlay" @click.self="$emit('close')">
      <div class="card">
        <button class="close-x" @click="$emit('close')">✕</button>
        <img src="@/assets/images/big-logo.png" alt="makalin" class="card-logo" />
        <h2 class="card-title">ปลดล็อคสิทธิประโยชน์</h2>
        <p class="card-desc">
          เชื่อมประวัติคนไข้หรือลงทะเบียน<br>
          เพื่อใช้ <strong>คูปองส่วนลด</strong> และ <strong>สะสม M-Coins</strong>
        </p>
        <button class="benefit-link" @click="showBenefits = !showBenefits">
          {{ showBenefits ? '▴' : '▾' }} ดูสิทธิประโยชน์ทั้งหมด
        </button>
        <div v-if="showBenefits" class="benefits-box">
          <p>✓ ใช้คูปองส่วนลดได้ทันที</p>
          <p>✓ สะสม M-Coins ทุกการซื้อ</p>
          <p>✓ เข้าถึงโปรโมชั่นพิเศษสำหรับสมาชิก</p>
          <p>✓ รับ 100 แต้มเมื่อเชื่อมประวัติสำเร็จ</p>
        </div>
        <button class="btn-line" @click="$emit('start-line-auth')" :disabled="isLineAuthenticating">
          <img src="@/assets/icons/white-line.svg" alt="line" class="line-icon" />
          เริ่มเชื่อมประวัติคนไข้/ลงทะเบียน
        </button>
        <p v-if="lineAuthError" class="err center">{{ lineAuthError }}</p>
        <button class="btn-ghost" @click="$emit('close')">
          ดำเนินการต่อโดยไม่ใช้คูปองส่วนลด
        </button>
      </div>
    </div>

    <div v-if="screen === 'phone'" class="overlay">
      <div class="card card-tall">
        <div class="card-header">
          <button class="back-in-card" @click="goTo('modal')">← ย้อนกลับ</button>
          <span class="card-header-title">เชื่อมประวัติคนไข้</span>
        </div>
        <StepDots :step="1" />
        <img src="@/assets/images/big-logo.png" alt="logo" class="card-logo-sm" />
        <p class="welcome-title">Welcome to M-Clinic</p>
        <p class="welcome-sub">Enter your phone number to access your coupons and rewards</p>
        <div class="field-group">
          <label>Phone Number</label>
          <input
            v-model="phone"
            type="tel"
            placeholder="เช่น 0812345678"
            maxlength="10"
            class="field-input"
            @input="onPhoneInput"
          />
          <p v-if="phoneErr" class="err">{{ phoneErr }}</p>
        </div>
        <button class="btn-primary" @click="startPhoneFlow" :disabled="isSendingOtp">
          {{ isSendingOtp ? 'กำลังตรวจสอบ...' : 'Verify' }}
        </button>
      </div>
    </div>

    <div v-if="screen === 'register'" class="overlay">
      <div class="card card-tall scrollable">
        <div class="card-header">
          <button class="back-in-card" @click="goTo('phone')">← ย้อนกลับ</button>
          <span class="card-header-title">ลงทะเบียนคนไข้ใหม่</span>
        </div>
        <StepDots :step="2" />
        <div class="field-row">
          <div class="field-group">
            <label>คำนำหน้า <span class="req">*</span></label>
            <div class="select-shell">
              <select v-model="form.title" class="field-input field-select">
                <option value="">เลือกคำนำหน้า</option>
                <option v-for="option in titleOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="field-group">
            <label>ชื่อ <span class="req">*</span></label>
            <input v-model="form.firstName" type="text" placeholder="First Name" class="field-input" />
          </div>
          <div class="field-group">
            <label>นามสกุล <span class="req">*</span></label>
            <input v-model="form.lastName" type="text" placeholder="Last Name" class="field-input" />
          </div>
        </div>
        <div class="field-group">
          <label>อีเมล</label>
          <input v-model="form.email" type="email" placeholder="john@example.com" class="field-input" />
        </div>
        <div class="field-group">
          <label>เบอร์โทรศัพท์</label>
          <input :value="phone" type="tel" class="field-input disabled" disabled />
          <p class="hint">⚑ กรอกอัตโนมัติ ไม่สามารถแก้ไขได้</p>
        </div>
        <div class="field-group">
          <label>วันเดือนปีเกิด <span class="req">*</span></label>
          <div class="dob-row">
            <select v-model="form.dobDay" class="field-input field-select">
              <option value="">Day</option>
              <option v-for="d in 31" :key="d" :value="d">{{ d }}</option>
            </select>
            <select v-model="form.dobMonth" class="field-input field-select">
              <option value="">Month</option>
              <option v-for="(m, i) in months" :key="i" :value="i + 1">{{ m }}</option>
            </select>
            <select v-model="form.dobYear" class="field-input field-select">
              <option value="">Year</option>
              <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
            </select>
          </div>
        </div>
        <div class="field-group">
          <label>ที่อยู่ <span class="req">*</span></label>
          <input v-model="form.address" type="text" placeholder="บ้านเลขที่ / หมู่บ้าน / ถนน" class="field-input" />
        </div>
        <div class="field-group">
          <label>สาขาที่สนใจเข้าใช้บริการ <span class="req">*</span></label>
          <div class="select-shell">
            <select v-model="selectedBranchValue" class="field-input field-select">
              <option value="">เลือกสาขา</option>
              <option v-for="branch in branches" :key="branch.value" :value="branch.value">
                {{ branch.label }}
              </option>
            </select>
          </div>
          <p class="hint">ใช้สำหรับบันทึกสาขาที่สะดวกในการเข้ารับบริการ</p>
        </div>
        <div class="field-group">
          <label>จังหวัด <span class="req">*</span></label>
          <div class="select-shell">
            <select v-model="selectedProvinceValue" class="field-input field-select">
              <option value="">เลือกจังหวัด</option>
              <option v-for="option in provinceChoices" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
          </div>
        </div>
        <div class="field-group">
          <label>อำเภอ/เขต <span class="req">*</span></label>
          <div class="select-shell">
            <select v-model="selectedDistrictValue" class="field-input field-select">
              <option value="">เลือกอำเภอ/เขต</option>
              <option v-for="option in districtChoices" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
          </div>
        </div>
        <div class="field-group">
          <label>ตำบล/แขวง <span class="req">*</span></label>
          <div class="select-shell">
            <select v-model="selectedSubDistrictValue" class="field-input field-select">
              <option value="">เลือกตำบล/แขวง</option>
              <option v-for="option in subDistrictChoices" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
          </div>
        </div>
        <div class="field-group">
          <label>รหัสไปรษณีย์ <span class="req">*</span></label>
          <input v-model="form.postcode" type="text" maxlength="5" class="field-input disabled" disabled />
        </div>
        <p v-if="registerErr" class="err">{{ registerErr }}</p>
        <button
          class="btn-primary"
          @click="registerCustomer"
          :disabled="isRegistering || !canSubmitRegister"
        >
          {{ isRegistering ? 'กำลังลงทะเบียน...' : 'Complete Registration' }}
        </button>
      </div>
    </div>

    <div v-if="screen === 'otp'" class="overlay">
      <div class="card card-center">
        <div class="card-header">
          <button class="back-in-card" @click="goTo(isRegisterFlow ? 'register' : 'phone')">← ย้อนกลับ</button>
          <span class="card-header-title">Verify Identity</span>
        </div>
        <StepDots :step="2" />
        <div class="otp-shield">🔒</div>
        <p class="otp-title">Verify Identity</p>
        <p class="otp-sub">We have sent an OTP to your phone<br><strong>{{ phone }}</strong></p>
        <div class="otp-row">
          <input
            v-for="(digit, i) in otpDigits"
            :key="i"
            :ref="el => otpRefs[i] = el"
            v-model="otpDigits[i]"
            type="tel"
            maxlength="1"
            class="otp-box"
            :class="{ filled: digit }"
            @input="onOtpInput(i)"
            @keydown.backspace="onOtpBackspace(i)"
          />
        </div>
        <p v-if="otpErr" class="err center">{{ otpErr }}</p>
        <button class="btn-dark" @click="verifyOtp" :disabled="isVerifyingOtp || otpCode.length < 4">
          {{ isVerifyingOtp ? 'Verifying...' : 'Verify & Sync' }}
        </button>
        <div class="resend-area">
          <span v-if="countdown > 0" class="resend-wait">Resend OTP SMS ({{ countdown }}s)</span>
          <button v-else class="resend-btn" @click="resendOtp">Resend OTP SMS</button>
        </div>
        <button class="change-btn" @click="goTo('phone')">Change phone number</button>
      </div>
    </div>

    <div v-if="screen === 'linked'" class="overlay">
      <div class="card card-center">
        <div class="synced-icon">⚠️</div>
        <h2 class="synced-title">Account Synced</h2>
        <p class="synced-desc">
          This phone number <strong>{{ phone }}</strong> is already<br>
          synced to a similar account in our system.<br><br>
          Please contact our agent at the clinic<br>
          for assistance with account verification.
        </p>
        <button class="btn-dark" @click="$emit('close')">Back to Login</button>
      </div>
    </div>

    <div v-if="screen === 'success'" class="overlay">
      <div class="card card-center">
        <svg width="72" height="72" viewBox="0 0 72 72">
          <circle cx="36" cy="36" r="36" fill="#DCFCE7"/>
          <circle cx="36" cy="36" r="26" fill="#86EFAC"/>
          <polyline points="20,38 30,48 52,24" stroke="#16A34A" stroke-width="4.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h2 class="success-title">All Set!</h2>
        <p class="success-desc">
          บัญชีของคุณพร้อมใช้งานแล้ว<br>
          หากเบอร์นี้ตรงกับข้อมูลคลินิก ระบบจะเชื่อม Makalin ID ให้โดยอัตโนมัติ
        </p>
        <div class="coins-row">
          <img src="@/assets/icons/m-coin.svg" class="coin-img" alt="coin" />
          <span>+100 M-Coins จะเข้าบัญชีอัตโนมัติหากคุณยังไม่เคยได้รับสิทธิ์นี้</span>
        </div>
        <button class="btn-success" @click="handleSuccess">{{ successLabel }}</button>
      </div>
    </div>

    <div v-if="alertMessage" class="overlay alert-overlay">
      <div class="card card-center alert-card">
        <div class="alert-icon">!</div>
        <p class="alert-text">{{ alertMessage }}</p>
        <button class="btn-dark" @click="closeAlert">ตกลง</button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onUnmounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

import userApi from '@/api/user'
import { isClinicCustomerNotFound } from '@/utils/apiErrors'
import { recallPhone } from '@/utils/phoneMemory'

const StepDots = {
  props: { step: Number },
  template: `
    <div class="step-dots">
      <template v-for="n in 2" :key="n">
        <span class="dot" :class="{ active: step===n, done: step>n }">
          {{ step > n ? '✓' : n }}
        </span>
        <span v-if="n<2" class="dot-line" :class="{ done: step>n }"></span>
      </template>
    </div>
  `
}

export default {
  name: 'SyncHistoryModal',
  components: { StepDots },
  props: {
    visible: { type: Boolean, default: false },
    fromPath: { type: String, default: '/my-cart' },
    isLineAuthenticating: { type: Boolean, default: false },
    lineAuthError: { type: String, default: '' },
    lineAuthCompletedAt: { type: Number, default: 0 },
    // Enter directly on a given screen instead of the LINE pitch screen. Used by
    // callers whose user is already authenticated (e.g. /user/verify).
    startScreen: { type: String, default: '' },
    initialPhone: { type: String, default: '' },
    initialBranchId: { type: [String, Number], default: null },
    // When false, an OTP that completes without a linked LINE account is accepted
    // as-is instead of forcing the LINE attach step.
    requireLineAccount: { type: Boolean, default: true },
    successPath: { type: String, default: '/my-coupons' },
    successLabelText: { type: String, default: 'ไปที่คูปองของฉัน →' },
  },
  emits: ['close', 'success', 'start-line-auth'],
  setup(props, { emit }) {
    const router = useRouter()
    const store = useStore()
    const { t } = useI18n()

    const screen = ref(props.startScreen || 'modal')
    const phone = ref('')
    const phoneErr = ref('')
    const branchErr = ref('')
    const showBenefits = ref(false)
    const selectedBranch = ref({})
    const selectedProvince = ref({})
    const selectedDistrict = ref({})
    const selectedSubDistrict = ref({})
    const isRegisterFlow = ref(false)
    const otpDigits = ref(['', '', '', ''])
    const otpRefs = ref([])
    const otpErr = ref('')
    const registerErr = ref('')
    // Errors the API states in words (e.g. the number is not in the clinic system) get a
    // popup of their own - inline text under the form is too easy to miss.
    const alertMessage = ref('')
    const countdown = ref(60)
    const isSendingOtp = ref(false)
    const isVerifyingOtp = ref(false)
    const isRegistering = ref(false)
    let timer = null

    const branches = computed(() => store.getters['user/getBranchOptions'])
    const provinceChoices = computed(() => store.state.user.provinces.map(i => ({ ...i, value: i.province_code, label: i.province_name })))
    const districtChoices = computed(() => store.state.user.districts.map(i => ({ ...i, value: i.district_code, label: i.district_name })))
    const subDistrictChoices = computed(() => store.state.user.subDistricts.map(i => ({ ...i, value: i.sub_district_code, label: i.sub_district_name })))
    const selectedBranchValue = computed({
      get: () => selectedBranch.value?.value || '',
      set: (value) => {
        const foundBranch = branches.value.find(branch => String(branch.value) === String(value))
        selectedBranch.value = foundBranch || {}
      },
    })
    const selectedProvinceValue = computed({
      get: () => selectedProvince.value?.value || '',
      set: (value) => {
        const found = provinceChoices.value.find(option => String(option.value) === String(value))
        selectedProvince.value = found || {}
      },
    })
    const selectedDistrictValue = computed({
      get: () => selectedDistrict.value?.value || '',
      set: (value) => {
        const found = districtChoices.value.find(option => String(option.value) === String(value))
        selectedDistrict.value = found || {}
      },
    })
    const selectedSubDistrictValue = computed({
      get: () => selectedSubDistrict.value?.value || '',
      set: (value) => {
        const found = subDistrictChoices.value.find(option => String(option.value) === String(value))
        selectedSubDistrict.value = found || {}
      },
    })
    const otpCode = computed(() => otpDigits.value.join(''))
    const successLabel = computed(() => props.successLabelText)
    const form = ref({
      title: '',
      firstName: '',
      lastName: '',
      email: '',
      dobDay: '',
      dobMonth: '',
      dobYear: '',
      address: '',
      postcode: '',
    })
    const titleOptions = [
      { value: 'นาย', label: 'นาย' },
      { value: 'นาง', label: 'นาง' },
      { value: 'นางสาว', label: 'นางสาว' },
      { value: 'Mr.', label: 'Mr.' },
      { value: 'Mrs.', label: 'Mrs.' },
      { value: 'Ms.', label: 'Ms.' },
    ]
    const titleToGender = {
      'นาย': 'M',
      'Mr.': 'M',
      'นาง': 'F',
      'นางสาว': 'F',
      'Mrs.': 'F',
      'Ms.': 'F',
    }
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    const years = Array.from({ length: 80 }, (_, i) => new Date().getFullYear() - i)
    const canSubmitRegister = computed(() => (
      !!form.value.title &&
      !!String(form.value.firstName || '').trim() &&
      !!String(form.value.lastName || '').trim() &&
      !!form.value.dobDay &&
      !!form.value.dobMonth &&
      !!form.value.dobYear &&
      !!String(form.value.address || '').trim() &&
      !!selectedBranch.value?.value &&
      !!selectedProvince.value?.value &&
      !!selectedDistrict.value?.value &&
      !!selectedSubDistrict.value?.value &&
      !!String(form.value.postcode || '').trim()
    ))

    const resetState = async (targetScreen = 'modal') => {
      // Set the screen up front so the caller's entry screen paints on the first
      // frame instead of flashing the LINE pitch while branches/provinces load.
      screen.value = targetScreen
      phone.value = ''
      phoneErr.value = ''
      branchErr.value = ''
      registerErr.value = ''
      showBenefits.value = false
      selectedBranch.value = {}
      selectedProvince.value = {}
      selectedDistrict.value = {}
      selectedSubDistrict.value = {}
      isRegisterFlow.value = false
      otpDigits.value = ['', '', '', '']
      otpErr.value = ''
      alertMessage.value = ''
      form.value = {
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        dobDay: '',
        dobMonth: '',
        dobYear: '',
        address: '',
        postcode: '',
      }
      countdown.value = 60
      isSendingOtp.value = false
      isVerifyingOtp.value = false
      isRegistering.value = false
      clearInterval(timer)
      store.commit('user/RESET_REQUEST_ID_OTP')
      await store.dispatch('user/fetchGetBranches')
      if (branches.value.length === 1) {
        selectedBranch.value = branches.value[0]
      }
    }

    watch(() => props.visible, async (val) => {
      if (!val) {
        clearInterval(timer)
        return
      }

      await resetState(props.startScreen || 'modal')

      // Fall back to the number the user already typed on the login / verify page.
      phone.value = props.initialPhone || recallPhone()
      if (props.initialBranchId !== null && props.initialBranchId !== undefined) {
        selectedBranchValue.value = props.initialBranchId
      }

      if (props.startScreen === 'register') {
        // Caller already knows this phone has no clinic customer, so go straight to
        // the registration form. The province list is normally loaded by startPhoneFlow.
        isRegisterFlow.value = true
        await store.dispatch('user/fetchGetProvince')
      } else if (!props.startScreen && props.lineAuthCompletedAt) {
        screen.value = 'phone'
      }
    })

    watch(() => props.lineAuthCompletedAt, (value) => {
      if (props.visible && value) {
        screen.value = 'phone'
      }
    })

    const goTo = (target) => {
      screen.value = target
      otpErr.value = ''
      registerErr.value = ''
    }

    const closeAlert = () => {
      alertMessage.value = ''
    }

    const goToRegister = async () => {
      isRegisterFlow.value = true
      await store.dispatch('user/fetchGetProvince')
      goTo('register')
    }

    const onPhoneInput = (e) => {
      phone.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10)
      phoneErr.value = ''
    }

    const validatePhone = () => {
      const pattern = /^(0[689])[0-9]{8}$/
      phoneErr.value = ''
      branchErr.value = ''
      if (pattern.test(phone.value) === false) {
        phoneErr.value = 'กรุณากรอกเบอร์โทรศัพท์ของท่านให้ถูกต้อง'
        return false
      }
      return true
    }

    const startCountdown = () => {
      clearInterval(timer)
      countdown.value = 60
      timer = setInterval(() => {
        countdown.value--
        if (countdown.value <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    }

    const sendOtp = async (branchId = null) => {
      isSendingOtp.value = true
      otpErr.value = ''
      try {
        await store.dispatch('user/fetchGetOTP', {
          phone: phone.value,
          branchId,
        })
        otpDigits.value = ['', '', '', '']
        startCountdown()
      } catch (err) {
        // No clinic record for this number: no message, just open the registration form.
        // Any other spoken reason gets a popup instead of small print under the form.
        if (isClinicCustomerNotFound(err?.detail)) await goToRegister()
        else if (err?.detail) alertMessage.value = err.detail
        else otpErr.value = 'ไม่สามารถส่ง OTP ได้ กรุณาลองใหม่อีกครั้ง'
        throw err
      } finally {
        isSendingOtp.value = false
      }
    }

    const startPhoneFlow = async () => {
      if (!validatePhone() || isSendingOtp.value) return
      isSendingOtp.value = true
      otpErr.value = ''
      alertMessage.value = ''
      try {
        const response = await store.dispatch('user/fetchCheckPhoneCustomer', phone.value)
        if (response?.is_conflict === true || response?.next_step === 'conflict') {
          isRegisterFlow.value = false
          clearInterval(timer)
          screen.value = 'linked'
          return
        }
        if (response?.next_step === 'register' || response?.has_customer === false) {
          await goToRegister()
          return
        }

        isRegisterFlow.value = false
        await sendOtp()
        goTo('otp')
      } catch (err) {
        // sendOtp has already dealt with it - popup, or straight to the register form.
        if (alertMessage.value || screen.value === 'register') return
        otpErr.value = err?.detail || 'ไม่สามารถตรวจสอบข้อมูลได้ กรุณาลองใหม่อีกครั้ง'
      } finally {
        isSendingOtp.value = false
      }
    }

    const registerCustomer = async () => {
      if (!canSubmitRegister.value || isRegistering.value) return
      isRegistering.value = true
      registerErr.value = ''
      try {
        const derivedGender = titleToGender[form.value.title]
        if (!derivedGender) {
          registerErr.value = 'กรุณาเลือกคำนำหน้าที่ถูกต้อง'
          return
        }
        await store.dispatch('user/fetchRegisterPhoneCustomer', {
          mobile_no: phone.value,
          title: form.value.title,
          first_name: String(form.value.firstName || '').trim(),
          last_name: String(form.value.lastName || '').trim(),
          gender: derivedGender,
          birth_date: `${form.value.dobYear}-${form.value.dobMonth}-${form.value.dobDay}`,
          address: String(form.value.address || '').trim(),
          branch_id: selectedBranch.value.value,
          province_code: selectedProvince.value.value,
          district_code: selectedDistrict.value.value,
          postcode: String(form.value.postcode || '').trim(),
          email: String(form.value.email || '').trim(),
          sub_district_name: selectedSubDistrict.value?.label || '',
        })
        goTo('otp')
      } catch (err) {
        registerErr.value = err?.detail || 'ไม่สามารถลงทะเบียนได้ กรุณาลองใหม่อีกครั้ง'
      } finally {
        isRegistering.value = false
      }
    }

    const onOtpInput = (i) => {
      if (otpDigits.value[i]) {
        otpDigits.value[i] = otpDigits.value[i].replace(/[^0-9]/g, '').slice(0, 1)
      }
      otpErr.value = ''
      if (otpDigits.value[i] && i < otpRefs.value.length - 1) {
        otpRefs.value[i + 1]?.focus()
      }
    }

    const onOtpBackspace = (i) => {
      if (!otpDigits.value[i] && i > 0) {
        otpRefs.value[i - 1]?.focus()
      }
    }

    const verifyOtp = async () => {
      if (otpCode.value.length < 4 || isVerifyingOtp.value) return
      isVerifyingOtp.value = true
      otpErr.value = ''
      try {
        await store.dispatch('user/fetchVerifyOTP', otpCode.value)
        let profile = await userApi.getProfileUser()
        store.commit('user/SET_USER_PROFILE', profile)
        if (props.requireLineAccount && !profile?.has_line_account) {
          const lineAccessToken = sessionStorage.getItem('line_sync_access_token')
          if (!lineAccessToken) {
            emit('start-line-auth', { attachLine: true })
            return
          }

          await store.dispatch('user/fetchLoginWithLine', {
            lineAccessToken,
            attachCurrentUser: true,
          })
          profile = await userApi.getProfileUser()
          store.commit('user/SET_USER_PROFILE', profile)
          sessionStorage.removeItem('line_sync_access_token')

          if (!profile?.has_line_account) {
            otpErr.value = 'ไม่สามารถเชื่อมบัญชี LINE ได้ กรุณาลองใหม่อีกครั้ง'
            return
          }
        }
        // The user is authenticated now, so carry any guest cart into their server cart
        // before fetchGetCart switches over to it.
        await store.dispatch('cart/fetchSyncGuestCart')
        await store.dispatch('cart/fetchGetCart')
        clearInterval(timer)
        screen.value = 'success'
      } catch (err) {
        if (err?.status === 409) {
          clearInterval(timer)
          screen.value = 'linked'
          return
        }
        otpErr.value = err?.detail || 'รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่'
      } finally {
        isVerifyingOtp.value = false
      }
    }

    const resendOtp = async () => {
      if (isSendingOtp.value) return
      try {
        await sendOtp(isRegisterFlow.value ? (selectedBranch.value?.value || null) : null)
      } catch (err) {
        // sendOtp already sets otpErr
      }
    }

    const handleSuccess = () => {
      emit('success')
      router.push(props.successPath)
    }

    watch(() => selectedProvince.value, (newValue) => {
      if (newValue?.value) {
        store.dispatch('user/fetchGetDistrict', newValue.value)
      }
      selectedDistrict.value = {}
      selectedSubDistrict.value = {}
      form.value.postcode = ''
    })

    watch(() => selectedDistrict.value, (newValue) => {
      if (newValue?.value) {
        store.dispatch('user/fetchGetSubDistrict', newValue.value)
      }
      selectedSubDistrict.value = {}
      form.value.postcode = ''
    })

    watch(() => selectedSubDistrict.value, (newValue) => {
      form.value.postcode = newValue?.postcode ? String(newValue.postcode) : ''
    })

    onUnmounted(() => clearInterval(timer))

    return {
      t,
      screen,
      phone,
      phoneErr,
      branchErr,
      registerErr,
      showBenefits,
      selectedBranch,
      selectedBranchValue,
      branches,
      selectedProvince,
      selectedProvinceValue,
      selectedDistrict,
      selectedDistrictValue,
      selectedSubDistrict,
      selectedSubDistrictValue,
      provinceChoices,
      districtChoices,
      subDistrictChoices,
      isRegisterFlow,
      otpDigits,
      otpRefs,
      otpErr,
      alertMessage,
      closeAlert,
      countdown,
      otpCode,
      isSendingOtp,
      isVerifyingOtp,
      isRegistering,
      successLabel,
      form,
      titleOptions,
      months,
      years,
      canSubmitRegister,
      goTo,
      onPhoneInput,
      startPhoneFlow,
      resendOtp,
      registerCustomer,
      onOtpInput,
      onOtpBackspace,
      verifyOtp,
      handleSuccess,
    }
  }
}
</script>

<style lang="scss" scoped>
.sync-modal-root { font-family: 'NotoSansThai', sans-serif; }

.overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.55);
  z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 16px;
}

.card {
  background: #fff; border-radius: 20px; padding: 24px;
  width: 100%; max-width: 420px; display: flex; flex-direction: column;
  align-items: center; gap: 12px; text-align: center; position: relative;
  max-height: 90vh; overflow-y: auto;
  &.card-tall { align-items: stretch; text-align: left; }
  &.card-center { align-items: center; text-align: center; }
  &.scrollable { overflow-y: auto; }
}

.close-x {
  position: absolute; top: 14px; right: 16px; background: none; border: none;
  font-size: 18px; color: #999; cursor: pointer;
}
.card-logo { width: 72px; }
.card-logo-sm { width: 52px; margin: 0 auto; }
.card-title { font-size: 21px; font-weight: bold; color: #1A1A2E; margin: 0; }
.card-desc { font-size: 14px; color: #555; line-height: 1.6; margin: 0; }

.card-header {
  display: flex; align-items: center; justify-content: center;
  position: relative; width: 100%; padding-bottom: 8px; border-bottom: 1px solid #f0f0f0;
}
.back-in-card {
  position: absolute; left: 0; background: none; border: none;
  color: var(--secondary-color, #4A58E5); font-size: 14px; cursor: pointer;
  font-family: 'NotoSansThai', sans-serif;
}
.card-header-title { font-size: 16px; font-weight: bold; color: #1A1A2E; }

:deep(.step-dots) { display: flex; align-items: center; justify-content: center; gap: 0; margin: 4px 0; }
:deep(.dot) {
  width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: bold; background: #E0E0E0; color: #999;
  &.active { background: var(--secondary-color, #4A58E5); color: #fff; }
  &.done { background: #22C55E; color: #fff; }
}
:deep(.dot-line) { height: 2px; width: 36px; background: #E0E0E0; flex-shrink: 0; &.done { background: #22C55E; } }

.benefit-link {
  background: none; border: none; color: var(--secondary-color, #4A58E5);
  font-size: 13px; cursor: pointer; text-decoration: underline; padding: 0;
}
.benefits-box {
  background: #F5F7FF; border-radius: 10px; padding: 10px 14px; width: 100%; text-align: left;
  > p { font-size: 13px; color: #333; margin: 3px 0; }
}

.btn-line {
  width: 100%; padding: 13px; background: #06C755; color: #fff; border: none;
  border-radius: 10px; font-size: 15px; font-weight: bold; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  font-family: 'NotoSansThai', sans-serif; &:hover { opacity: 0.9; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
}
.line-icon { width: 20px; height: 20px; }
.btn-ghost {
  width: 100%; padding: 12px; background: transparent; color: #888;
  border: 1px solid #D0D0D0; border-radius: 10px; font-size: 14px; cursor: pointer;
  font-family: 'NotoSansThai', sans-serif; &:hover { background: #F9F9F9; }
}
.btn-primary {
  width: 100%; padding: 13px;
  background: linear-gradient(90deg, #4A58E5 0%, #6D2E46 100%);
  color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: bold;
  cursor: pointer; font-family: 'NotoSansThai', sans-serif;
  &:disabled { background: #C3C3C3; cursor: not-allowed; }
}
.btn-dark {
  width: 100%; padding: 13px; background: #1A1A2E; color: #fff; border: none;
  border-radius: 10px; font-size: 15px; font-weight: bold; cursor: pointer;
  font-family: 'NotoSansThai', sans-serif;
  &:disabled { background: #C3C3C3; cursor: not-allowed; }
}
.btn-success {
  width: 100%; padding: 13px; background: #22C55E; color: #fff; border: none;
  border-radius: 10px; font-size: 15px; font-weight: bold; cursor: pointer;
  font-family: 'NotoSansThai', sans-serif;
}

.welcome-title { font-size: 24px; font-weight: 800; color: #1A1A2E; text-align: center; margin: 4px 0 0; }
.welcome-sub { font-size: 14px; color: #596273; line-height: 1.6; text-align: center; margin: 0 0 8px; }

.field-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  > label {
    font-size: 14px;
    font-weight: 700;
    color: #1A1A2E;
  }
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.field-input {
  width: 100%; box-sizing: border-box; border: 1px solid #DADFE8; border-radius: 12px;
  padding: 14px 16px; font-size: 15px; color: #1A1A2E;
}

.disabled {
  background: #F4F6FA;
  color: #8A93A5;
}

.hint {
  margin: 0;
  font-size: 12px;
  color: #8A93A5;
}

.req,
.required {
  color: #DC2626;
}

.select-shell {
  position: relative;
}

.field-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  padding-right: 44px;
  cursor: pointer;
}

.select-shell::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 16px;
  width: 10px;
  height: 10px;
  border-right: 2px solid #7B8190;
  border-bottom: 2px solid #7B8190;
  transform: translateY(-65%) rotate(45deg);
  pointer-events: none;
}

.dob-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.otp-shield {
  width: 56px; height: 56px; border-radius: 18px; background: #EEF2FF;
  display: flex; align-items: center; justify-content: center; font-size: 26px;
}
.otp-title { font-size: 22px; font-weight: 800; color: #1A1A2E; margin: 4px 0 0; }
.otp-sub { font-size: 14px; color: #596273; line-height: 1.6; margin: 0; }
.otp-row { display: flex; gap: 10px; justify-content: center; }
.otp-box {
  width: 48px; height: 56px; border-radius: 14px; border: 1px solid #D9DEEA;
  text-align: center; font-size: 26px; font-weight: 700; color: #1A1A2E;
  &.filled { border-color: #4A58E5; }
}

.err { color: #DC2626; font-size: 13px; margin: 0; }

.alert-overlay { z-index: 1100; }
.alert-card { gap: 16px; max-width: 340px; padding: 28px 24px; }
.alert-icon {
  width: 48px; height: 48px; border-radius: 50%; background: #FEE2E2; color: #DC2626;
  display: flex; align-items: center; justify-content: center;
  font-size: 26px; font-weight: bold; line-height: 1;
}
.alert-text { font-size: 15px; color: #1A1A2E; line-height: 1.6; margin: 0; }
.alert-card .btn-dark { width: 100%; }
.center { text-align: center; }

.resend-area {
  display: flex; flex-direction: column; align-items: center; gap: 6px;
}
.resend-wait,
.resend-btn,
.change-btn {
  font-size: 13px; color: #596273;
}
.resend-btn,
.change-btn {
  border: none; background: transparent; cursor: pointer; text-decoration: underline;
}

.success-title { font-size: 24px; font-weight: 800; color: #1A1A2E; margin: 0; }
.success-desc { font-size: 14px; line-height: 1.7; color: #596273; margin: 0; }
.coins-row {
  width: 100%; border-radius: 14px; background: #F5F7FF; padding: 14px 16px; box-sizing: border-box;
  display: flex; align-items: center; gap: 10px; color: #24324A; font-size: 13px; line-height: 1.5; text-align: left;
}
.coin-img { width: 28px; height: 28px; flex-shrink: 0; }

.synced-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #FEF3C7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}

.synced-title {
  font-size: 24px;
  font-weight: 800;
  color: #1A1A2E;
  margin: 0;
}

.synced-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #596273;
  margin: 0;
}
</style>
